import { SvgProps } from './types'

export const ArmchairIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M11 22V11A4 4 0 0 1 15 7H25A4 4 0 0 1 29 11V22"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 22A4 4 0 0 0 7 26V30"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29 22A4 4 0 0 1 33 26V30"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 26H33" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 30H33" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 30V33" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M30 30V33" stroke={drawColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
